//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { events } from "@nuskin/ns-util";
import { UserService } from "@nuskin/ns-account";

import NsHeaderProfile from "./NsHeaderProfile.vue";
import NsHeaderProfileToggle from "./NsHeaderProfileToggle.vue";

export default {
  name: "NsHeaderProfileDropdown",
  components: {
    NsHeaderProfile,
    NsHeaderProfileToggle
  },
  props: {
    /**
     * Hides the Signup text and link
     */
    hideSignUp: Boolean,
    /**
     * List of potential navigation links
     */
    profileMenu: {
      type: Array,
      default: () => []
    },
    /**
     * The url where signout link takes you
     */
    signOutUrl: {
      type: String,
      default: ""
    },
    /**
     * The url where signup link takes you
     */
    signUpUrl: {
      type: String,
      default: ""
    },
    /**
     * Translations for component
     * Required keys: id, greeting, enjoyLoyalty, newCustomerLabel,
     * signUpTodayLabel, signIn, signOut, signUp
     */
    translations: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    isLoggedIn: UserService.isLoggedIn(),
    profilePopupOpen: false
  }),
  mounted() {
    this.startEventListeners();
  },
  methods: {
    handlePopupMouseleave() {
      this.profilePopupOpen = false;
    },
    handleDropdownToggle() {
      this.profilePopupOpen = !this.profilePopupOpen;
    },
    startEventListeners() {
      // LOGIN EVENTS
      events.subscribe(events.authentication.LOGIN_COMPLETE, () => {
        this.isLoggedIn = UserService.isLoggedIn();
      });

      events.subscribe(events.authentication.LOGOUT, () => {
        this.isLoggedIn = false;
      });
    }
  }
};
